<template>
  <Modal
    hide-close-button
    :modal-style="{ width: '600px' }"
    persistent
    title="Set Monthly allowance for feature"
  >
    <div class="q-py-sm">
      <OrganisationFeatureAllowanceForm
        v-for="(
          organisationFeatureAllowance, index
        ) in updatedOrganisationFeatureAllowances"
        :key="index"
        ref="form"
        class="q-my-md q-mb-lg"
        :model-value="organisationFeatureAllowance"
        @update:model-value="onInput"
      />
      <div class="row justify-end">
        <QBtn
          label="Cancel"
          no-caps
          @click="cancel"
        />
        <QBtn
          class="q-mx-md"
          color="black"
          label="Save"
          no-caps
          @click="validateAndSave"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

import OrganisationFeatureAllowanceForm from "src/components/organisations/featuresTab/OrganisationFeatureAllowanceForm.vue";

function sortKey(allowance) {
  const { organisationContract } = allowance;
  const { contractStart } = organisationContract;

  const contractOrder = organisationContract.isSLA() ? "1" : "2";

  return `${contractOrder}-${contractStart}`;
}

export default {
  name: "FeatureAllowanceModal",
  components: {
    Modal,
    OrganisationFeatureAllowanceForm,
  },
  props: {
    organisationFeatureAllowances: {
      type: Array,
      required: true,
    },
  },
  emits: ["cancel", "save"],
  data() {
    return {
      updatedOrganisationFeatureAllowances: [],
    };
  },
  watch: {
    organisationFeatureAllowances: {
      immediate: true,
      deep: true,
      handler() {
        const currentAllowances = this.organisationFeatureAllowances;

        const updatedAllowances = currentAllowances.map((allowance) =>
          allowance.dup()
        );

        updatedAllowances.sort((firstAllowance, secondAllowance) => {
          const firstKey = sortKey(firstAllowance);
          const secondKey = sortKey(secondAllowance);

          if (firstKey > secondKey) return 1;
          if (firstKey < secondKey) return -1;

          return 0;
        });

        this.updatedOrganisationFeatureAllowances = updatedAllowances;
      },
    },
  },
  methods: {
    onInput(organisationFeatureAllowance) {
      const { organisationContractId } = organisationFeatureAllowance;

      this.updatedOrganisationFeatureAllowances =
        this.updatedOrganisationFeatureAllowances.map((allowance) => {
          if (organisationContractId === allowance.organisationContractId) {
            return organisationFeatureAllowance;
          }

          return allowance;
        });
    },
    cancel() {
      this.$emit("cancel");
    },
    validateAndSave() {
      Promise.all(this.$refs.form.map((form) => form.validate())).then(
        (values) => {
          if (values.includes(false)) return;

          this.save();
        }
      );
    },
    save() {
      this.$emit("save", this.updatedOrganisationFeatureAllowances);
    },
  },
};
</script>
